// extracted by mini-css-extract-plugin
export var autoExpand = "_21-b";
export var container = "_21-a";
export var containerWidth = "_21-8";
export var disabled = "_21-2";
export var error = "_21-3";
export var fullWidth = "_21-9";
export var highlightContainer = "_21-5";
export var inputWrapper = "_21-0";
export var small = "_21-1";
export var textarea = "_21-4";
export var validatedTextarea = "_21-6";
export var visuallyHidden = "_21-7";